export default __webpack_public_path__ + "static/media/7.eee1e3b4.jpg";